import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { atomicHub } from 'services/api';
import { Bitrix24Context } from 'contexts/legacy/Bitrix24Context';
import chatLogo from 'assets/logos/chat.png';
import iconKory from 'assets/logos/icon-kory-half.png';

const CrossSellDashboard: React.FC = () => {
	const intl = useIntl();
	const { getCurrentUserContext } = useContext(Bitrix24Context);

	const handleClick = async () => {
		const bx24 = (globalThis as Record<string, any>)['BX24'];
		const auth = bx24 ? bx24.getAuth() : { domain: 'solinka.bitrix24.com' };
		const domain = auth.domain;

		try {
			const user = await getCurrentUserContext(domain, auth.member_id);
			await atomicHub.post(
				'/cta-tracking/events',
				{
					eventType: 'click',
					componentType: 'banner',
					eventLocation: 'powerzap_control_panel',
					applicationSource: 'powerzap',
					userContext: user,
					abTestVariant: { variant: 'koral' },
					destinationUrl: `https://${domain}/market/detail/brs4.atomichat/?from=search&text=kory`,
					buttonText: intl.formatMessage({ id: 'cta_kory_dashboard_cta' }),
				},
				{
					headers: {
						Authorization: `Bearer ${process.env.REACT_APP_ATOMIC_HUB_API_TOKEN}`,
					},
				},
			);
		} catch (error) {
			console.error('handleClick error', error);
		} finally {
			globalThis.open(
				`https://${domain}/market/detail/brs4.atomichat/?from=search&text=kory`,
				'_blank',
				'noopener,noreferrer',
			);
		}
	};

	return (
		<button
			onClick={handleClick}
			className="font-onest"
			style={{
				display: 'flex',
				flexDirection: 'row',
				width: '100%',
				margin: '5px 2px 2px 2px',
				padding: 'clamp(16px, 4vw, 28px)',
				borderRadius: 8,
				backgroundColor: '#ff6849',
				cursor: 'pointer',
				minHeight: 110,
				border: 'none',
				textAlign: 'left',
				overflow: 'hidden',
				position: 'relative',
				alignItems: 'center',
			}}
		>
			<img
				src={chatLogo}
				alt="Kory chat"
				style={{
					alignSelf: 'flex-start',
					height: 'clamp(14px, 2vw, 20px)',
					flexShrink: 0,
					marginRight: 'clamp(8px, 2vw, 16px)',
					zIndex: 2,
					objectFit: 'contain',
				}}
			/>

			<img
				src={iconKory}
				alt=""
				style={{
					position: 'absolute',
					bottom: -20,
					left: -55,
					height: 90,
					pointerEvents: 'none',
					zIndex: 1,
					objectFit: 'contain',
				}}
			/>

			<div
				style={{
					flex: 1,
					minWidth: 0,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-end',
					justifyContent: 'center',
					gap: 'clamp(6px, 1vw, 10px)',
					zIndex: 9,
				}}
			>
				<div
					style={{
						textAlign: 'right',
						fontSize: 'clamp(16px, 2vw, 24px)',
						lineHeight: 1.4,
						color: '#131629',
						fontWeight: 500,
						whiteSpace: 'pre-line',
						wordBreak: 'break-word',
					}}
				>
					<FormattedMessage
						id="cta_kory_dashboard_title"
						values={{
							highlight: (chunks: React.ReactNode) => (
								<span
									style={{
										color: '#FFFBFA',
										fontWeight: 700,
									}}
								>
									{chunks}
								</span>
							),
							b: (chunks: React.ReactNode) => <span style={{ fontWeight: 600 }}>{chunks}</span>,
						}}
					/>
				</div>

				<div
					style={{
						textAlign: 'right',
						fontSize: 'clamp(15px, 2vw, 24px)',
						lineHeight: 1.2,
						color: '#FFFBFA',
						fontWeight: 500,
						wordBreak: 'break-word',
					}}
				>
					<FormattedMessage id="cta_kory_dashboard_cta" />
				</div>
			</div>
		</button>
	);
};

export default CrossSellDashboard;
